import axios from "axios";
const API = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: {
        "Content-Type": "application/json",
    },
    withCredentials: true,
});
const handleLogout = () => {
    const preservedDob = localStorage.getItem("z_dob_modal_dismissed");
    localStorage.clear();
    if (preservedDob != null) {
        localStorage.setItem("z_dob_modal_dismissed", preservedDob);
    }
    // Navigate to signin page
    const currentPath = window.location.pathname + window.location.search;
    const encodedRedirect = encodeURIComponent(currentPath);
    window.location.href = `/verify-phone/direct?redirect=${encodedRedirect}`;
};
API.interceptors.response.use((response) => {
    return response;
}, (error) => {
    // Handle 401 Unauthorized errors
    if (error.response && error.response.status === 401) {
        console.log("Unauthorized access detected. Redirecting to verification...");
        handleLogout();
    }
    return Promise.reject(error);
});
export default API;
